import { render, staticRenderFns } from "./modelVideo.vue?vue&type=template&id=7519572d&scoped=true&"
import script from "./modelVideo.vue?vue&type=script&lang=js&"
export * from "./modelVideo.vue?vue&type=script&lang=js&"
import style0 from "./modelVideo.vue?vue&type=style&index=0&id=7519572d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7519572d",
  null
  
)

export default component.exports